import { SHOTS_PER_DAY } from './constants';

export type SceneKey = 'MenuScene' | 'PlayScene' | 'ResultScene';

/**
 * Pure routing decision: given today's local state, return the scene to start.
 * See spec §4.2 for branch table; Plan #5 §6.1 for version-aware completion.
 *
 * Accepts a minimal structural type so it can be unit-tested without the
 * full LocalState shape; production callers pass the actual LocalState.
 */
export function decideStartScene(
  state: { history: Record<string, { schemaVersion?: 1 | 2; shots: readonly unknown[] } | undefined> },
  today: string,
): SceneKey {
  const record = state.history[today];
  if (!record) return 'MenuScene';
  const len = record.shots.length;
  if (len === 0) return 'MenuScene';
  // v1 = 5-shot complete; v2 = SHOTS_PER_DAY-shot complete; default to v1 for legacy.
  const limit = record.schemaVersion === 2 ? SHOTS_PER_DAY : 5;
  if (len < limit) return 'PlayScene';
  return 'ResultScene';
}
